
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "@/components/ui/form";
import { toast } from "sonner";
import { demoSchema, type DemoFormData } from "./validation-schemas";
import { useTranslation } from "react-i18next";
import { sendToGoogleChat } from "@/utils/googleChat";
import { PersonalInfoSection, CompanyInfoSection, DemoPreferencesSection } from "./demo/FormSections";
import { SubmitButton } from "./demo/SubmitButton";

const GOOGLE_CHAT_WEBHOOK_URL = "VOTRE_WEBHOOK_URL_ICI";

const DemoForm = () => {
  const { t } = useTranslation('contact');
  const form = useForm<DemoFormData>({
    resolver: zodResolver(demoSchema),
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      jobTitle: "",
      teamSize: "",
      preferredDate: "",
      interest: "",
    },
  });

  const onSubmit = async (data: DemoFormData) => {
    try {
      const formattedMessage = `
🌟 *Nouvelle demande de démonstration !* 🌟

👤 *Contact*
• Nom : ${data.firstName} ${data.lastName}
• Email : ${data.email}

🏢 *Entreprise*
• Nom : ${data.company}
• Poste : ${data.jobTitle}
• Taille de l'équipe : ${data.teamSize}

📊 *Intérêt principal*
• ${data.interest}

📅 *Disponibilité souhaitée*
• ${data.preferredDate}

⏰ Reçu le ${new Date().toLocaleString('fr-FR')}

_Wow ! Une nouvelle demande de démo, c'est génial ! 🎯 
Pensons à organiser rapidement un premier contact pour garder l'enthousiasme ! 💪_
`;

      await sendToGoogleChat(GOOGLE_CHAT_WEBHOOK_URL, {
        text: formattedMessage,
      });

      console.log(data);
      toast.success(t("form.success"));
      form.reset();
    } catch (error) {
      console.error(error);
      toast.error(t("form.error"));
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
        <PersonalInfoSection form={form} />
        <CompanyInfoSection form={form} />
        <DemoPreferencesSection form={form} />
        <SubmitButton />
      </form>
    </Form>
  );
};

export default DemoForm;
